import React, { FunctionComponent } from 'react';
import { SanityNavLink } from '../../types/common';
import { ExternalLinkIcon, InternalLinkIcon } from '../Icons';
import InternalLink from '../InternalLink';
import './styles.scss';

type PageHeaderLinksProps = {
  links: SanityNavLink[];
}

const PageHeaderLinks: FunctionComponent<PageHeaderLinksProps> = ({ links }) => {
  return (
    <nav className='links-list'>
      <ul>
        {links.map((link) => {
          if (link.typeLink === 'internal' && link.page) {
            return (
              <li key={link._key}>
                <InternalLink
                  reference={link.page}
                >
                  {link.name}
                  <InternalLinkIcon />
                </InternalLink>
              </li>
            )
          }
          return (
            <li key={link._key}>
              <a href={link.externalLink || '#'} target='_blank' rel='noreferrer noopener'>
                {link.name}
                <ExternalLinkIcon />
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  );
}

export default PageHeaderLinks;
